import { render } from "./TimelineWithPagination.vue?vue&type=template&id=2012fc99"
import script from "./TimelineWithPagination.vue?vue&type=script&lang=js"
export * from "./TimelineWithPagination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__